export default __webpack_public_path__ + "static/media/35.f2afbd46.jpg";